module.exports = __webpack_public_path__ + "img/SPV.54440021.svg";